export default "__VITE_ASSET__D7elXH6___"